import axiosConfig from "./axiosConfig";

// One existing outreach-draft thread for a lead's contact, with the turn count - feeds
// the "a draft already exists" (v2) badge on each contact's Draft email button. Batched:
// one call returns every thread for the lead, so a contact list costs one request.
export interface OutreachThreadSummary {
  outreachMessageId: string;
  role: string;
  contactApolloId: string | null;
  turnCount: number;
}

const getLeadOutreachThreads = async (
  authToken: string,
  leadId: string
): Promise<OutreachThreadSummary[]> => {
  const { data } = await axiosConfig.get(`/leads/${leadId}/outreach-threads`, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return (data?.threads ?? []) as OutreachThreadSummary[];
};

export default getLeadOutreachThreads;
